import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetPropertyScoresResponseTO } from 'models/bookingDotCom/PropertyScore';
import API from 'services/API';

export const PROPERTY_SCORES_BASE_QUERY_KEY = 'booking-dot-com-scores';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetPropertyScoresResponseTO>,
  'queryKey' | 'queryFn'
>;

type UseFetchBookingDotComPropertyScoresArgs = {
  propertyUid: string;
} & ReactQueryOptions;

const useFetchBookingDotComPropertyScores = ({
  propertyUid,
  enabled = true,
  ...options
}: UseFetchBookingDotComPropertyScoresArgs) => {
  return useAppQuery<GetPropertyScoresResponseTO>({
    queryKey: [PROPERTY_SCORES_BASE_QUERY_KEY, 'detail', propertyUid],
    queryFn: async () => {
      const response = await API.get<GetPropertyScoresResponseTO>(
        '/api/internal/bookingdotcom/properties/property-scores',
        { params: { resourceUid: propertyUid } },
      );

      return response.data;
    },
    enabled,
    cacheTime: 5 * 60 * 1000,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchBookingDotComPropertyScores;
